import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { parseCookie } from "./cookie";
import { isBrowserEnv, THEME } from "./constants";
import LocalCookie, { CookieKey } from "util/LocalCookie";
import { useKoaContext } from "./KoaContext";
import { DEFAULT_LANG } from "constants/vars";

export const useCookie = (cookieKey: CookieKey) => {
  if (isBrowserEnv) {
    return LocalCookie.get(cookieKey);
  }

  const ctx = useKoaContext();
  const COINTR_LOCAL_COOKIE = parseCookie(
    ctx?.cookies?.get("COINTR_LOCAL_COOKIE")
  );
  return COINTR_LOCAL_COOKIE?.[cookieKey];
};

export const useSSRTheme = () => {
  let theme = "";
  const ctx = useKoaContext();
  if (isBrowserEnv) {
    theme = LocalCookie.get(CookieKey.THEME);
  } else {
    theme = ctx?.cookies?.get(CookieKey.THEME);
  }
  return theme || THEME.DARK;
};

export const useSSRLocale = () => {
  return useCookie(CookieKey.LANG) || DEFAULT_LANG;
};

export const useConnectLocaleUrl = () => {
  const { locales } = useParams();

  return useCallback(
    (url = "") => {
      if (/^https?:\/\//.test(url)) return url;
      return locales ? `/${locales}${url}` : url;
    },
    [locales]
  );
};
